import { createReducer } from "@reduxjs/toolkit";

import { UsersListFilter } from "@shared/interfaces";

import * as actions from "./actions";
import { UsersStateType } from "../interface";

const defaultUserShortFilter: UsersListFilter = {
  page: 0,
  limit: 8,
  search: "",
};

const defaultUserSummaryFilter: UsersListFilter = {
  ...defaultUserShortFilter,
  limit: 50,
};

export const initialState: UsersStateType = {
  usersShort: {
    rows: null,
    totalCount: 0,
    filter: { ...defaultUserShortFilter },
  },
  usersSummary: {
    rows: null,
    totalCount: 0,
    filter: { ...defaultUserSummaryFilter },
  },
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.getShortUsers.success, (state, action) => {
    const { rows, clear, count } = action.payload;
    const stateRows = state.usersShort.rows || [];
    state.usersShort.rows = !clear ? [...stateRows, ...rows] : [...rows];
    state.usersShort.totalCount = count;
  });
  builder.addCase(actions.setShortUsersListFilter, (state, action) => {
    state.usersShort.filter = action.payload || { ...defaultUserShortFilter };
  });
  builder.addCase(actions.setSummaryUsersListFilter, (state, action) => {
    state.usersSummary.filter = action.payload || { ...defaultUserSummaryFilter };
  });
  builder.addCase(actions.getSummaryUsers.success, (state, action) => {
    const { rows, clear, count } = action.payload;
    const stateRows = state.usersSummary.rows || [];
    state.usersSummary.rows = !clear ? [...stateRows, ...rows] : [...rows];
    state.usersSummary.totalCount = count;
  });
});

export { reducer as UsersReducer };
